/**
 * Sigilo de pessoal do FP&A (ADR 0049, plano R14): a lista do que é valor de pessoal. Toda mudança
 * leva o motivo; o banco confere de novo a permissão e guarda o histórico.
 */
import { z } from 'zod';

const reason = z.string().trim().min(3, 'Registre o motivo').max(1000);

export const fpaPayrollRuleInput = z.object({
  classificationId: z.string().uuid(),
  reason,
});
export type FpaPayrollRuleInput = z.infer<typeof fpaPayrollRuleInput>;

export const fpaPayrollRuleStatusInput = z.object({
  isActive: z.boolean(),
  reason,
});
